<ngx-loading-bar [color]="'var(--primary)'" height="7px"></ngx-loading-bar>
<lib-tour-overlay></lib-tour-overlay>

<router-outlet></router-outlet>

@if (isDisconnected) {
<div
  class="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-white"
  style="z-index: 1050"
>
  <div class="text-center">
    <div
      class="spinner-border text-primary"
      role="status"
      style="width: 3.5rem; height: 3.5rem"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
    <h5 class="mt-4 text-secondary fw-normal">
      {{ 'ReconnectingMessage' | translate }}
    </h5>
  </div>
</div>
}

<lib-modal #connectionModal [closable]="false">
  <ng-template #body>
    <div class="text-center">
      <div
        class="alert alert-danger py-3 px-3 d-block mx-auto col-9 text-center mb-0"
      >
        {{ 'DisconnectInternet' | translate }}
      </div>
    </div>
  </ng-template>
</lib-modal>
